import '@styles/pages/guided-search.scss';

import { number } from '@elements/number-formatter';
import { flashbags } from '@organisms/header/flashbags';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import App from './guided-search/App.vue';

const app = createApp(App);

app.config.compilerOptions.whitespace = 'preserve';
app.config.globalProperties.$companyName = window.COMPANY_NAME;
app.config.globalProperties.$linkCgu = window.initialAppState.link_cgu;
app.config.globalProperties.$linkPoc = window.initialAppState.link_poc;
app.config.globalProperties.$linkRecaptcha = window.initialAppState.link_recaptcha;
app.config.globalProperties.$offer_count = number(window.initialAppState.offer_count);
app.config.globalProperties.$home_url = window.initialAppState.home_url;
app.config.globalProperties.$search_url = window.initialAppState.search_url;
app.config.globalProperties.$trustpilotAccountId = window.TRUSTPILOT_ACCOUNT_ID;
app.config.globalProperties.$trustpilotWidgetTrustScoreId = window.TRUSTPILOT_WIDGET_TRUST_SCORE_ID;

flashbags();

const router = createRouter({
  routes: [
    {
      path: '/confier-ma-recherche',
      name: 'guided-search-app',
      component: App,
    },
  ],
  history: createWebHistory(),
});

const pinia = createPinia();

app.use(router);
app.use(pinia);
app.mount('#guided-search-app');
